module.exports = __webpack_public_path__ + "static/media/am2.0cd094d2.webp";